var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuteNoti2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.645 2.92188C8.49958 2.92188 5.94329 5.47816 5.94329 8.62363V11.37C5.94329 11.9497 5.69621 12.8334 5.40162 13.3276L4.30879 15.1426C3.63408 16.264 4.09972 17.5089 5.3351 17.927C9.43087 19.2954 13.8497 19.2954 17.9455 17.927C19.0953 17.5469 19.599 16.188 18.9718 15.1426L17.879 13.3276C17.5939 12.8334 17.3468 11.9497 17.3468 11.37V8.62363C17.3468 5.48767 14.781 2.92188 11.645 2.92188Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6455 1.12012L1.64551 21.1201",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4038 3.19737C13.1092 3.11184 12.8051 3.04532 12.4915 3.00731C11.5792 2.89328 10.7049 2.9598 9.8877 3.19737C10.1633 2.49415 10.8475 2 11.6457 2C12.444 2 13.1282 2.49415 13.4038 3.19737Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4967 18.2695C14.4967 19.8375 13.2138 21.1204 11.6458 21.1204C10.8666 21.1204 10.1443 20.7973 9.63118 20.2842C9.11802 19.771 8.79492 19.0488 8.79492 18.2695",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteNoti2);
export default __webpack_public_path__ + "static/media/unmute_noti2.1837b10a562ae6d80db5ea0e3c9b89c9.svg";
export { ForwardRef as ReactComponent };